/* src/app/views/template/components/edit-template-menu/edit-template-shelf-talker-menu/edit-template-shelf-talker-brands-menu/edit-template-shelf-talker-brands-section/edit-template-shelf-talker-brands-section.component.scss */
/*# sourceMappingURL=edit-template-shelf-talker-brands-section.component.css.map */
